// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/auth/login";
import Layout from "./pages/layout/layout";
import Home from "./compnenets/home";
import "./App.css";
import Dashboard from "./pages/dashboard/dashboard";
import MyProjects from "./pages/my-projects/my-projects";
import ProjectDetail from "./pages/my-projects/project-details/project-detail";
import Dpr from "./pages/dpr/dpr";
import ListOfResources from "./pages/dpr/resourceList/list";
import RequireAuth from "./services/auth/routeProtect";
import MyApproval from "./pages/my-approval/my-approval";
import Risklist from "./pages/risk-register/risk-list";
import Dprlist from "./pages/dpr/dprlist";
import Issuelist from "./pages/issue-register/issue-list";
import Rearninglist from "./pages/dpr/learning/leraning-list";
import Quality from "./pages/quality/quality";
import Saftey from "./pages/dpr/saftey/saftey";
import Archival from "./pages/dpr/archival/archival";

import ProjectHandover from "./pages/project-handover/project-handover";
import DocumentRepository from "./pages/document-repository/document-repository";
import PostHandoverComplaintList from "./pages/post-handover-complaint/post-handover-complaint-list";
import Report from "./pages/report/report";
import PortfolioReport from "./pages/portfolio-report/portfolio";
import Mytasks from "./pages/wpowner/mytasks.js";
// import ForgotPassword from './pages/auth/forgot-password.js';
// import PasswordVerify from './pages/auth/password-verify.js';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/*<Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-verify" element={<PasswordVerify />} /> */}
        <Route path="/" element={<Layout />}>
          <Route
            index
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="my-projects"
            element={
              <RequireAuth>
                <MyProjects />
              </RequireAuth>
            }
          />
          <Route
            path="safety"
            element={
              <RequireAuth>
                <Saftey />
              </RequireAuth>
            }
          />
          <Route
            path="project-archival"
            element={
              <RequireAuth>
                <Archival />
              </RequireAuth>
            }
          />

          <Route
            path="project-details"
            element={
              <RequireAuth>
                <ProjectDetail />
              </RequireAuth>
            }
          />
          <Route
            path="dpr"
            element={
              <RequireAuth>
                <Dpr />
              </RequireAuth>
            }
          />
          <Route
            path="dpr-list"
            element={
              <RequireAuth>
                <Dprlist />
              </RequireAuth>
            }
          />
          <Route
            path="resourece"
            element={
              <RequireAuth>
                <ListOfResources />
              </RequireAuth>
            }
          />
          <Route
            path="project-allocation"
            element={
              <RequireAuth>
                <MyProjects />
              </RequireAuth>
            }
          />
          <Route
            path="portfolio"
            element={
              <RequireAuth>
                <PortfolioReport />
              </RequireAuth>
            }
          />
          <Route
            path="my-approval"
            element={
              <RequireAuth>
                <MyApproval />
              </RequireAuth>
            }
          />
          <Route
            path="risk-register"
            element={
              <RequireAuth>
                <Risklist />
              </RequireAuth>
            }
          />
          <Route
            path="issue-register"
            element={
              <RequireAuth>
                <Issuelist />
              </RequireAuth>
            }
          />
          <Route
            path="learning"
            element={
              <RequireAuth>
                <Rearninglist />
              </RequireAuth>
            }
          />
          <Route
            path="quality"
            element={
              <RequireAuth>
                <Quality />
              </RequireAuth>
            }
          />
          <Route
            path="project-handover"
            element={
              <RequireAuth>
                <ProjectHandover />
              </RequireAuth>
            }
          />
          <Route
            path="documnet-repository"
            element={
              <RequireAuth>
                <DocumentRepository />
              </RequireAuth>
            }
          />
          <Route
            path="post-handover-complaint"
            element={
              <RequireAuth>
                <PostHandoverComplaintList />
              </RequireAuth>
            }
          />
          <Route
            path="report"
            element={
              <RequireAuth>
                <Report />
              </RequireAuth>
            }
          />
          <Route
            path="my-tasks"
            element={
              <RequireAuth>
                <Mytasks />
              </RequireAuth>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
